import type { Manager } from '../types';

interface Props {
  onSelect: (id: string) => void;
  claimedIds: string[]; // ids currently active in other sessions (best-effort)
  sessionUid: string | null;
  managers: Manager[];
  leagueName?: string;
  onSwitchLeague?: () => void;
}

export function ManagerSelectionScreen({ sessionUid, onSelect, managers, leagueName, onSwitchLeague }: Props) {
  return (
    <div className="fixed inset-0 bg-gradient-to-br from-slate-950 via-brand-bg to-slate-900 flex items-center justify-center p-4 z-50">
      <div className="panel p-8 max-w-lg w-full text-center">
        <h1 className="text-4xl font-extrabold bg-gradient-to-r from-teal-300 to-cyan-400 bg-clip-text text-transparent mb-2">
          🏈 NFL Fantasy Auction
        </h1>
        {leagueName && (
          <p className="text-teal-300 font-semibold mb-1">{leagueName}</p>
        )}
        <p className="text-slate-400 mb-8">Pick your seat. The draft begins when you join.</p>
        <div className="grid grid-cols-2 gap-3">
          {managers.map(m => (
            <button
              key={m.id}
              onClick={() => onSelect(m.id)}
              className="p-5 rounded-xl bg-slate-800 hover:bg-teal-600 transition border border-slate-700 hover:border-teal-400 group"
            >
              <div className="text-3xl mb-1">{m.emoji}</div>
              <div className="text-lg font-bold text-white">{m.name}</div>
            </button>
          ))}
        </div>
        {onSwitchLeague && (
          <button onClick={onSwitchLeague} className="mt-6 text-xs text-slate-400 hover:text-teal-300 underline">
            Switch league
          </button>
        )}
        <p className="text-xs text-slate-600 mt-4">Session: {sessionUid?.slice(0, 8) ?? 'connecting…'}</p>
        <p className="text-[10px] text-slate-600 mt-2 font-mono" title={`Built ${__BUILD_TIME__}`}>
          v{__APP_VERSION__}
        </p>
      </div>
    </div>
  );
}
